class CartCheckoutButton {
  static init(root = document) {
    root.querySelectorAll('[data-cart-checkout]').forEach((button) => {
      if (button.dataset.checkoutInit === 'true') return;
      button.dataset.checkoutInit = 'true';
      button.addEventListener('click', CartCheckoutButton.onCheckoutClick);
    });
  }

  static resetAll(root = document) {
    root.querySelectorAll('[data-cart-checkout]').forEach((button) => {
      button.classList.remove('loading');
      button.removeAttribute('aria-busy');

      if (!button.hasAttribute('disabled')) {
        button.removeAttribute('aria-disabled');
      }

      const spinner = button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    });
  }

  static onCheckoutClick(event) {
    const button = event.currentTarget;

    if (button.disabled || button.getAttribute('aria-disabled') === 'true' || button.classList.contains('loading')) {
      return;
    }

    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');

    const spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => CartCheckoutButton.init());
} else {
  CartCheckoutButton.init();
}

document.addEventListener('shopify:section:load', (event) => {
  CartCheckoutButton.init(event.target);
});

// Browser back/forward restores the cart page from cache with the loading state still applied.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    CartCheckoutButton.resetAll();
  }
});

window.addEventListener('popstate', () => {
  CartCheckoutButton.resetAll();
});
